<template>
  <main class="nc-content" :class="{ 'nc-content--padded': padded }">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'NcContent',
  props: {
    padded: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.nc-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
}

.nc-content--padded {
  padding: var(--nc-spacing-md);
}
</style>

